export default [
    {
      path: '/cargo',
      name: 'cargo',
      meta: {
        login: true
      }
    },
    { path: '/map/CargoFlowList', name: 'CargoFlowList', component: resolve => require(['@/views/cargo/ChemicalLogisticsList'], resolve)},
    { path: '/map/CargoFlowMap', name: 'CargoFlowMap', component: resolve => require(['@/views/cargo/ChemicalLogisticsControl'], resolve)},
    { path: '/map/VoyageManagement', name: 'VoyageManagement', component: resolve => require(['@/views/cargo/VoyageManagement'], resolve)},
    { path: '/map/VoyageManagementMap', name: 'VoyageManagementMap', component: resolve => require(['@/views/cargo/VoyageManagementMap'], resolve)},
    { path: '/cargo/DrawCargoFlow', name: 'DrawCargoFlow', component: resolve => require(['@/views/cargo/DrawCargoFlow'], resolve)},
    // { path: '/map/VesselConfigControl', name: 'VesselConfigControl', component: resolve => require(['@/views/map/VesselConfigControl'], resolve)},
  ]


// WEBPACK FOOTER //
// ./src/config/router/cargo.js